import React from 'react';
import { motion } from 'framer-motion';
import { CircleCheckIcon, CircleSlashIcon, UserIcon } from 'lucide-react';
import { forkPaths, forkStart } from '../../data/site';
export function ForkDiagram() {
  return <figure className="rounded-2xl border border-mist bg-white p-6 shadow-[0_30px_70px_-50px_rgba(14,36,54,0.6)] lg:p-9" data-id="element-154" data-mp="3nzoru197t6a6">
      <motion.div initial={{
      opacity: 0,
      y: -6
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.4
    }} className="mx-auto flex max-w-md items-center justify-center gap-2.5 rounded-xl border border-ink/15 bg-bone px-5 py-3.5 text-center text-[15px] font-medium text-ink" data-id="element-155" data-mp="3s10ima3trxjy">
        <UserIcon className="h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-156" data-mp="34e261nitt9rb" />
        {forkStart}
      </motion.div>

      {/* Fork connector */}
      <svg viewBox="0 0 200 32" className="mt-1 hidden h-8 w-full text-mist sm:block" fill="none" aria-hidden="true" preserveAspectRatio="none" data-id="element-157" data-mp="jmi35nbk1fqb">
        <motion.path d="M100 0 V10 Q100 16 88 16 H54 Q42 16 42 22 V32" stroke="currentColor" strokeWidth="1.5" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 0.5,
        delay: 0.25
      }} data-id="element-158" data-mp="omwebe8gd5sk" />
        <motion.path d="M100 0 V10 Q100 16 112 16 H146 Q158 16 158 22 V32" stroke="currentColor" strokeWidth="1.5" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 0.5,
        delay: 0.25
      }} data-id="element-159" data-mp="r1f97edhnvw4" />
      </svg>

      <div className="mt-4 grid gap-4 sm:mt-0 sm:grid-cols-2" data-id="element-160" data-mp="daig7mfnhcoj">
        {forkPaths.map((path, pathIndex) => {
        const dead = path.tone === 'dead';
        return <motion.ol key={path.title} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45,
          delay: 0.5 + pathIndex * 0.12
        }} className="flex flex-col gap-2" data-id="element-161" data-mp="89uunga6xo1p" data-mpi={pathIndex}>
              <li className={`rounded-lg px-3 py-2.5 text-center text-sm font-semibold ${dead ? 'bg-clay/10 text-clay' : 'bg-teal/10 text-teal'}`} data-id="element-162" data-mp="3qidicdt1hr8a">
                {path.title}
              </li>
              {path.nodes.map((node, i) => {
            const terminal = i === path.nodes.length - 1;
            return <li key={node} className={['flex flex-1 items-center gap-2.5 rounded-xl border px-4 py-4 text-[15px] leading-snug', terminal && dead ? 'border-clay/40 bg-clay/5 font-semibold text-clay' : terminal ? 'border-teal/40 bg-teal/5 font-semibold text-teal' : 'border-mist bg-bone text-ink'].join(' ')} data-id="element-163" data-mp="36xmpmy7ndycp" data-mpi={i}>
                    {terminal ? dead ? <CircleSlashIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-164" data-mp="3puwamjsmfjw2" /> : <CircleCheckIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-165" data-mp="3psjw6gm2nrnr" /> : null}
                    {node}
                  </li>;
          })}
            </motion.ol>;
      })}
      </div>
    </figure>;
}